<template>
  <div class="cso-anonymized-hint" :class="{'expanded': expanded}">
    <i></i>
    <p>
      <span v-html="$t(`anonymizedHint.text${fullOrshort}`)" />
      <a tabindex="0" @click="toggle()" @keydown.enter="toggle()" class="expand-link">
        {{ $t(`anonymizedHint.show${lessOrMore}`) }}
      </a>
    </p>
  </div>
</template>

<script lang="ts">
export default {
  name: 'CsoAnonymizedHint',

  data () {
    return {
      expanded: false
    }
  },

  computed: {
    fullOrshort () {
      return this.expanded ? 'Full' : 'Short'
    },
    lessOrMore () {
      return this.expanded ? 'Less' : 'More'
    }
  },

  methods: {
    toggle () {
      this.expanded = !this.expanded
    }
  }
}
</script>

<style lang="scss">
.cso-anonymized-hint {
  background-color: $yellow-light;
  border-left: 4px solid $yellow;
  padding: 20px 16px;
  font-family: $font-family-regular;
  display: flex;
  gap: 12px;

  i {
    background-color: white;
    border-radius: 50%;
    height: 48px;
    flex: 0 0 48px;
    background-image: url(/static/icons/information.svg);
    background-repeat: no-repeat;
    background-size: cover;
    background-origin: content-box;
    padding: 12px;
  }

  p {
    margin: 0;
    line-height: 18px;
  }

  a {
    cursor: pointer;
    text-decoration: underline;
    color: $blue-16;
    white-space: nowrap;
  }

  &.expanded a.expand-link {
    display: block;
    margin-top: 12px;
  }

  @include xs {
    padding: 20px;

    i {
      display: none;
    }
  }
}
</style>